import styled, { createGlobalStyle } from 'styled-components';
import { Form, Field, ErrorMessage } from 'formik';

export const Wrapper = styled.div`
  max-width: 320px;
  padding: 32px 24px;

  @media (min-width: 768px) {
    max-width: 480px;
    padding: 48px 48px;
  }
`;

export const Text = styled.p`
  font-family: ${props => props.theme.fonts.display};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  font-size: 18px;
  text-align: center;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 26px;
    margin-bottom: 28px;
  }
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  @media (min-width: 768px) {
    gap: 16px;
  }
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  font-family: ${props => props.theme.fonts.body};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${props => props.theme.brand.muted};
  align-items: center;
`;

export const LabelText = styled.span`
  &::after {
    content: '*';
    color: ${props => props.theme.colors.error};
    padding: 1px;
  }
`;

export const StyledField = styled(Field)`
  width: 100%;
  max-width: 280px;
  height: 44px;
  padding: 4px 16px;
  border: 1.5px solid rgba(225, 224, 218, 1);
  border-radius: ${props => props.theme.radii.pill};
  background: ${props => props.theme.brand.canvas};
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
  color: ${props => props.theme.colors.textPrimary};
  transition: ${props => props.theme.transition.main};

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.secondary};
  }

  @media (min-width: 768px) {
    max-width: 380px;
    height: 52px;
    font-size: 15px;
  }
`;

export const PhoneFieldGlobalStyles = createGlobalStyle`
  .react-international-phone-input-container {
    width: 100%;
    max-width: 280px;

    @media (min-width: 768px) {
      max-width: 380px;
    }
  }

  .react-international-phone-input-container .react-international-phone-input {
    &:focus {
      outline: none;
      border-color: ${props => props.theme.colors.secondary};
    }
  }

  .react-international-phone-input-container .react-international-phone-country-selector-button {
    border-color: rgba(225, 224, 218, 1);
    background: ${props => props.theme.brand.canvas};
  }

  .react-international-phone-input {
    width: 100%;
    border-color: rgba(225, 224, 218, 1) !important;
    background: ${props => props.theme.brand.canvas};
  }

  .react-international-phone-input-container .react-international-phone-country-selector-button {
    width: 44px;

    @media (min-width: 768px) {
      width: 52px;
    }
  }
`;

export const StyledTextField = styled(Field)`
  width: 100%;
  max-width: 280px;
  height: 88px;
  padding: 12px 16px;
  border: 1.5px solid rgba(225, 224, 218, 1);
  border-radius: ${props => props.theme.radii.medium};
  background: ${props => props.theme.brand.canvas};
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
  color: ${props => props.theme.colors.textPrimary};
  overflow-x: auto;
  transition: ${props => props.theme.transition.main};

  &::placeholder {
    color: ${props => props.theme.brand.muted};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.secondary};
  }

  @media (min-width: 768px) {
    max-width: 380px;
    height: 110px;
  }
`;

export const StyledErrorMessage = styled(ErrorMessage)`
  font-family: ${props => props.theme.fonts.body};
  color: ${props => props.theme.colors.error};
  font-size: 11px;
  text-transform: none;

  @media (min-width: 768px) {
    font-size: 12px;
  }
`;

export const DivErrorMessage = styled.div`
  font-family: ${props => props.theme.fonts.body};
  color: ${props => props.theme.colors.error};
  font-size: 11px;
  text-transform: none;

  @media (min-width: 768px) {
    font-size: 12px;
  }
`;

export const Btn = styled.button`
  margin-top: 8px;
  padding: 14px 32px;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.colors.secondary};
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.hoverColor};
  }

  @media (min-width: 768px) {
    margin-top: 12px;
    padding: 16px 40px;
    font-size: 16px;
  }
`;
